import { render } from "./CalendarTab.vue?vue&type=template&id=2cec22a2&scoped=true"
import script from "./CalendarTab.vue?vue&type=script&lang=js"
export * from "./CalendarTab.vue?vue&type=script&lang=js"

import "./CalendarTab.vue?vue&type=style&index=0&id=2cec22a2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cec22a2"]])

export default __exports__